<template>
  <div>
    <div class="opc-cart__today" v-if="mx_is">
      <span class="opc-cart__today__label">{{ this.$t('billing.order_summary.todays_total') }}</span>
      <span class="opc-cart__today__value">
        <vloader :loading="mx_loading" :value="$money(max(getTodaysTotal, 0))" />
      </span>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
import vloader from './vloader.vue';
import mx from './mx.vue';
import { mapGetters } from 'vuex';
export default {
  mixins: [mx],
  components: {
    vloader,
  },
  computed: {
    ...mapGetters(['getTodaysTotal']),
  },
  methods: {
    max: Math.max
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/scss-utils.scss';

.opc-cart__today {
  font-family: Almaden Sans;
  font-size: 22px;
  font-weight: 700;
  line-height: 33px;
  text-align: left;
  color: #00053d;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  @include simplifyStyle() {
    font-size: 20px;
  }
}
</style>
